module.exports = __webpack_public_path__ + "static/media/md-tv.08c72b39.svg";